import { eventService } from "fleet/service/event";
import { eventNameService } from "fleet/service/event-name";
import { createApiSaga } from "redux-store/api-sagas";

import {
  LOAD_EVENTS_V3_FETCH,
  LOAD_EVENTS_V3_SUCCESS,
  LOAD_EVENTS_V3_NAME,
} from "./actions";

const loadEventsV3Saga = createApiSaga({
  service: eventService.loadV3,
  serviceName: "eventService.loadV3",
  fetchAction: LOAD_EVENTS_V3_FETCH,
  successAction: LOAD_EVENTS_V3_SUCCESS,
});

const loadEventsV3NameSaga = createApiSaga({
  fetchAction: LOAD_EVENTS_V3_NAME,
  service: eventNameService.load,
  serviceName: "eventNameService.load",
  reload: false,
});

const eventsV3Sagas = [loadEventsV3Saga(), loadEventsV3NameSaga()];

export { eventsV3Sagas, loadEventsV3Saga, loadEventsV3NameSaga };
